// src/utils/useBackendStatus.js
import { useEffect, useState, useContext } from "react";
import axios from "axios";
import config from "../config";
import { AuthContext } from "../AuthProvider";

export default function useBackendStatus() {
  const { keycloak } = useContext(AuthContext);

  // undefined = (nog) geen status → oranje
  const [online, setOnline] = useState(undefined);

  useEffect(() => {
    if (!keycloak?.token) {
      setOnline(undefined);   // geen token = geen status
      return;
    }

    let cancelled = false;

    const checkBackend = async () => {
      try {
        const res = await axios.get(`${config.apiBaseUrl}/health`, {
          headers: { Authorization: `Bearer ${keycloak.token}` },
          withCredentials: false,
        });

        if (cancelled) return;

        setOnline(res.status === 200 && res.data === "OK");
      } catch (err) {
        if (cancelled) return;

        if (err?.response?.status === 401) {
          // Laat de gebruiker ingelogd; markeer backend als offline zodat we niet
          // in een refresh-loop belanden bij een korte token-issue.
          setOnline(false);
        } else {
          setOnline(false);
        }
      }
    };

    checkBackend();
    const interval = setInterval(checkBackend, 60000);

    return () => {
      cancelled = true;
      clearInterval(interval);
    };
  }, [keycloak?.token]);   // iets strakker dan [keycloak]

  return online; // true | false | undefined
}
